import styled from "styled-components";

import { ReactComponent as Calendar } from 'assets/icons/calendar-icon.svg'
import { ReactComponent as Wallet } from 'assets/icons/wallet-icon.svg'

import MaskImage from 'assets/img/hexa-mask.png';

export const Container = styled.div``

export const Subheader = styled.div`
  height: 126px;
  width: 100%;

  position: relative;

  background: var(--blue00);
  background: linear-gradient(90deg, rgba(0,105,182,1) 0%, rgba(0,120,208,1) 10%);

  .profile__subheader-button{
    width: fit-content;
    height: 20px;

    position: absolute;
    top: calc(50% - 10px);
    left: 222.1px;

    border: 0;
    outline: none;
    background: transparent;
    cursor: pointer;

    &:hover{
      background: var(--blue);
      color: var(--blue00);
    }
  }

  .profile__subheader-icon{
    height: 20px;
    width: auto;
    stroke: #fff;
  }

  @media (max-width: 1170px){
    .profile__subheader-button{
      top: calc(30% - 10px);
      left: 20px;
    }
  }
`

export const Content = styled.main`
  width: calc(100% - 176px);
  height: fit-content;
  margin-left: 176px;
  padding: 0 0 45.4px;

  .profile__content-pic-container{
    width: fit-content;
    margin: 0 auto;

    position: relative;
    top: -120.4px;
  }

  .profile__content-image,
  .profile__content-before-image{
    mask-image: url(${MaskImage});
    mask-size: contain;
    mask-repeat: no-repeat;
    mask-position: center;
  }

  .profile__content-before-image{
    width: 132.34px;
    height: 152.03px;

    position: absolute;
    bottom: 0;
    left: 0;

    display: inline-block;

    background: rgb(40,133,219);
    background: linear-gradient(30deg, rgba(40,133,219,1) 0%, rgba(255,255,255,1) 100%);
  }

  .profile__content-image{
    width: 162.96px;
    height: 187.2px;
    margin: 0 17.8px 0 18.4px;

    object-fit: cover;
    background-color: var(--bluef0);
  }

  .profile__content-edit-button{
    width: 51.96px;
    height: 45.23px;

    position: absolute;
    right: 0;
    bottom: 27.4px;

    border: 0;
    outline: none;
    background: transparent;
    cursor: pointer;
  }

  @media (max-width: 1170px){
    width: 100%;
    margin: 0 0 50px 0;
    padding: 0 0 120px;
  }
`

export const Username = styled.h1`
  width: 90%;
  margin: -90px auto 0;

  font-size: 2rem;
  color: var(--blue00);
  text-align: center;
`

export const AgendaContainer = styled.div`
  width: 99.8%;
  height: fit-content;
  margin: 30px auto;
  padding: 20px 10px;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 13.8px;

  border-radius: 3px;
  background-color: var(--blueE5);

  .profile__agenda__button{
    width: 99%;
    max-width: 350px;
    height: 55px;
    padding: 0 20px;

    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;

    text-decoration: none;
    border: 0;
    border-radius: 30px;
    outline: none;
    background: #fff;
    cursor: pointer;
    transition: filter 0.3s;

    &:hover{
      filter: brightness(0.9);
    }
  }

  .profile__agenda__button-title{
    height: fit-content;

    font-size: 1.1rem;
    color: var(--blue00);
    text-align: center;
  }
`

export const CalendarIcon = styled(Calendar)`
  height: 30px;
  width: auto;
`

export const WalletIcon = styled(Wallet)`
  height: 30px;
  width: auto;
`

export const ButtonsList = styled.ul`
  width: 95%;
  max-width: 600px;
  height: 350px;
  margin: 0 auto;

  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
`

export const Section = styled.section`
  width: 100%;
  height: fit-content;
  margin-top: -93px;

  display: flex;
  flex-direction: column;
  align-items: center;

  .profile__section__title{
    font-size: 1.4375rem;
    color: var(--blue00);
  }

  .profile__section__form{
    width: 90%;
    max-width: 386.54px;
    height: 568.03px;
    margin-top: 27.4px;
    padding: 28.6px 0 37.7px;

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    border-radius: 38px;
    background-color: var(--bluef0);
  }

  .profile__section__form-input-wrapper{
    width: 80%;
    height: fit-content;
    margin: 0 auto;
  }

  .profile__section__form-label,
  .profile__section__form-input{
    width: 100%;

    display: block;
  }

  .profile__section__form-label{
    font-size: 1.125rem;
    color: var(--blue00);
  }

  .profile__section__form-input{
    height: 47.02px;
    margin-top: 7.4px;
    padding: 0 23.7px;

    color: var(--grayad);
    font-size: 1rem;
    border: 0;
    outline: none;
    border-radius: 19px;
    box-shadow: 0 3px 6px rgba(0,0,0,0.15);
  }

  .profile__section__form-button{
    width: 80%;
    height: 48.26px;
    margin: 7.4px auto 0;

    border: 0;
    border-radius: 38px;
    background-color: var(--blue00);
    font-size: 1.0625rem;
    color: #fff;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16);
    cursor: pointer;
    transition: filter 0.3s, opacity 0.3s;

    &:not(:disabled):hover {
      filter: brightness(1.1);
    }

    &:disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }
`
